import {
    combineReducers
} from 'redux'

import userReducer from './user'
import appReducer from './appReducer'
import formsReducer from './formsReducer'
import modalsReducer from './modalsReducer'

const rootReducer = combineReducers({
    app: appReducer,
    user: userReducer,
    forms: formsReducer,
    modals: modalsReducer
})

export default rootReducer